'use strict';

var loadExternalScript = require('../utils/loadExternalScript');
var googleMapsPromise;

/**
 * Returns the Google Maps API key from either a page-level hidden input
 * or the site-wide meta tag injected into the head.
 *
 * @returns {string} Google Maps API key.
 */
function getGoogleMapsApiKey() {
    return $('#google-maps-api-key').first().val()
        || $('meta[name="google-maps-api-key"]').attr('content')
        || '';
}

/**
 * Loads the Google Maps JavaScript API only when required.
 *
 * @returns {Promise<Object>} Resolves with the google.maps namespace.
 */
function loadGoogleMaps() {
    if (window.google && window.google.maps) {
        return Promise.resolve(window.google.maps);
    }

    if (googleMapsPromise) {
        return googleMapsPromise;
    }

    var apiKey = getGoogleMapsApiKey();

    if (!apiKey) {
        return Promise.reject(new Error('Google Maps API key is not configured.'));
    }

    googleMapsPromise = loadExternalScript('https://maps.googleapis.com/maps/api/js?key='
        + encodeURIComponent(apiKey)
        + '&libraries=places,geometry').then(function () {
        if (!(window.google && window.google.maps)) {
            throw new Error('Google Maps API was loaded without the google.maps namespace.');
        }

        return window.google.maps;
    }).catch(function (error) {
        googleMapsPromise = null;
        throw error;
    });

    return googleMapsPromise;
}

module.exports = {
    load: loadGoogleMaps
};
